import React, { Component, Fragment } from 'react'
import { HashRouter as Router, Route, Switch } from 'react-router-dom'
import ReactGA from 'react-ga'
import * as v from './views'
import { store } from './store'
import config from './config'


const GARoute = (page) => {
    return <Route exact={page.exact} path={page.path} render={(props)=>{
        document.title = store.getState().Translations.translations[page.title] ? store.getState().Translations.translations[page.title][store.getState().Translations.locales[store.getState().Translations.currentLocale]] : page.title + ' | ' + store.getState().Translations.translations['project.name'][store.getState().Translations.locales[store.getState().Translations.currentLocale]]
        ReactGA.pageview(page.path, [], page.title)
        return <page.component {...props}/>
    }} />
}


class MainRouter extends Component {
    componentDidMount() {
        ReactGA.initialize(config.GoogleAnalyticsID);
        if(localStorage.getItem('locale')) {
            store.dispatch({type: 'SET_LOCALE', payload:localStorage.getItem('locale')});
        }
    }
    render() {
        const self = this;
        return (
            <Router>
                <Switch>
                    {Object.keys(config.Pages).map(key => (
                        <GARoute key={key} 
                            exact={config.Pages[key].exact} 
                            path={key} 
                            title={config.Pages[key].title} 
                            component={v[config.Pages[key].view]}
                        />
                    ))}
                    <Route component={v['NotFound']}/>
                </Switch>
            </Router>
        );
    }
}

export default MainRouter;



// WEBPACK FOOTER //
// ./src/routes.js